import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import '../sicak-kahveler/KahveDetay.css';
import masala from '../../../../assets/menu/icecekler/sicak-icecekler/masala.jpeg';

const Masala = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Masala bilgileri
  const icecek = {
    name: 'Masala',
    price: '₺239,90',
    image: masala
  };

  const aciklama = 'Yeşil çay, kakule, kabuk tarçın, zencefil, zerdeçal, rezene, yıldız anason, karanfil, gül yaprakları';

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={icecek.image} alt={icecek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{icecek.name} - {icecek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{aciklama}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={icecek.image} alt={icecek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{icecek.name} - {icecek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{aciklama}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default Masala;
